import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

// Shared room banner styling
export const useRoomBannerStyles = makeStyles((theme: Theme) => ({
  // Apply this classname to an <img> HTMLImageElement
  root: {
    objectFit: 'cover',
    objectPosition: 'center',
    maxHeight: theme.spacing(30),
    width: '100%',
  },
}));
